import React from 'react';
import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';
import baseStyles from '../base.module.scss';

interface IProps {
  title?: string,
  className?: string,
  url: string,
}

const GetStartedButton = ({ title = 'Get Started', className = baseStyles.secondaryBtn, url }: IProps) => (
  <a
    suppressHydrationWarning
    href={ url }
  >
    <Button
      variant={ ButtonVariantType.action }
      className={ className }
      type="button"
      title={ title }
      dataTest="getStartedButton"
    />
  </a>
);

export default GetStartedButton;
